import { render } from "./MarketPulseStrip.vue?vue&type=template&id=4b61231e&scoped=true"
import script from "./MarketPulseStrip.vue?vue&type=script&lang=js"
export * from "./MarketPulseStrip.vue?vue&type=script&lang=js"

import "./MarketPulseStrip.vue?vue&type=style&index=0&id=4b61231e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b61231e"]])

export default __exports__